export default () =>{
    
    const allModals = document.querySelectorAll('.modal')
    const allOpenClicks = document.querySelectorAll('.show-popup')
    const allOpenClicksMobile = document.querySelectorAll('.show-popup-mobile')
    const allNoActions = document.querySelectorAll('.no-action')
    const enterHCP = document.querySelector('#enter-hcp')
    const hcpWindow = document.querySelector('#for-practitioners')
    const mainShowHCP = document.querySelector('.show-hcp-banner')
    const setcookies =  (cname, cvalue, exdays) =>{
        const d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        let expires = "expires="+ d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }
    if(enterHCP){
        enterHCP.addEventListener('click',function(e){
            e.preventDefault();
            hcpWindow.classList.remove('open')
            setcookies('HCP_Banner','YES',14)
        })
    }
    const closeModal = (modals) =>{
        modals.forEach(item=>{
            item.classList.remove('open')   
        })
    };

    const modalOpenClicks = (modals) =>{
        
        modals.forEach(item=>{
            item.addEventListener('click',function(e){
                if(!isMobile()){
                    e.preventDefault()
                    closeModal(allModals)
                    let target = document.querySelector('#'+item.dataset.target)
                    target.classList.add('open')
                }
        
            })
        })
    }
    const modalOpenClicksMobile = (modals) =>{
        
        modals.forEach(item=>{
            item.addEventListener('click',function(e){
                if(isMobile()){
                    e.preventDefault()
                    closeModal(allModals)
                    let target = document.querySelector('#'+item.dataset.target)
                    target.classList.add('open')
                }
        
            })
        })
    }

    const mainMenuClearHref = (items)=>{
        items.forEach(element => {
            if(isMobile()) {
                element.href = "javascript:void(0)"
                element.addEventListener('click',e=>{
                    //e.preventDefault()
                    
                })
            }
        });
    }
    mainMenuClearHref(allNoActions)
    closeModal(allModals);
    if(mainShowHCP && hcpWindow){
        hcpWindow.classList.add('open')
    }
    modalOpenClicks(allOpenClicks)
    modalOpenClicksMobile(allOpenClicksMobile)

}